var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTarget(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6667 12V8C12.6667 7.632 12.9647 7.33333 13.3333 7.33333C13.702 7.33333 14 7.632 14 8V12C14 13.1027 13.1027 14 12 14H4C2.89733 14 2 13.1027 2 12V4C2 2.89733 2.89733 2 4 2H8C8.36867 2 8.66667 2.29867 8.66667 2.66667C8.66667 3.03467 8.36867 3.33333 8 3.33333H4C3.632 3.33333 3.33333 3.63267 3.33333 4V12C3.33333 12.3673 3.632 12.6667 4 12.6667H12C12.368 12.6667 12.6667 12.3673 12.6667 12ZM11.7187 3.33867L10.6634 3.33333C10.2947 3.33133 9.99807 3.03133 10.0001 2.66333C10.0021 2.296 10.3001 2 10.6667 2H10.6701L13.3347 2.01333C13.7014 2.01533 13.9981 2.31267 13.9981 2.67933L14.0001 5.33267C14.0001 5.70133 13.7021 6 13.3341 6H13.3334C12.9654 6 12.6667 5.702 12.6667 5.334L12.6661 4.27667L8.4714 8.47133C8.3414 8.60133 8.17073 8.66667 8.00007 8.66667C7.8294 8.66667 7.65873 8.60133 7.52873 8.47133C7.26807 8.21067 7.26807 7.78933 7.52873 7.52867L11.7187 3.33867Z",
    fill: "#ABABAB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9508_26913",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 12,
    height: 12
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6667 12V8C12.6667 7.632 12.9647 7.33333 13.3333 7.33333C13.702 7.33333 14 7.632 14 8V12C14 13.1027 13.1027 14 12 14H4C2.89733 14 2 13.1027 2 12V4C2 2.89733 2.89733 2 4 2H8C8.36867 2 8.66667 2.29867 8.66667 2.66667C8.66667 3.03467 8.36867 3.33333 8 3.33333H4C3.632 3.33333 3.33333 3.63267 3.33333 4V12C3.33333 12.3673 3.632 12.6667 4 12.6667H12C12.368 12.6667 12.6667 12.3673 12.6667 12ZM11.7187 3.33867L10.6634 3.33333C10.2947 3.33133 9.99807 3.03133 10.0001 2.66333C10.0021 2.296 10.3001 2 10.6667 2H10.6701L13.3347 2.01333C13.7014 2.01533 13.9981 2.31267 13.9981 2.67933L14.0001 5.33267C14.0001 5.70133 13.7021 6 13.3341 6H13.3334C12.9654 6 12.6667 5.702 12.6667 5.334L12.6661 4.27667L8.4714 8.47133C8.3414 8.60133 8.17073 8.66667 8.00007 8.66667C7.8294 8.66667 7.65873 8.60133 7.52873 8.47133C7.26807 8.21067 7.26807 7.78933 7.52873 7.52867L11.7187 3.33867Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9508_26913)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#ABABAB"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTarget);
export default __webpack_public_path__ + "static/media/target.4e404e575dc91907051117e29f6cb41d.svg";
export { ForwardRef as ReactComponent };